import { Link, useParams } from "react-router";
import { SchrijvenTopicRenderer } from "../../../components/schrijven/SchrijvenTopicRenderer";
import { getSchrijvenTopicBySlug } from "../../../data/schrijven-study/topics";
import { useT } from "../../../lib/use-t";

export function SchrijvenLerenTopicPage() {
  const { slug } = useParams<{ slug: string }>();
  const t = useT();
  const topic = slug ? getSchrijvenTopicBySlug(slug) : undefined;

  if (!topic) {
    return (
      <main className="flex-1 mx-auto w-full max-w-3xl px-5 sm:px-6 py-8 sm:py-12 space-y-3">
        <h1 className="text-2xl font-semibold tracking-tight">{t("schrijven.leren.topic.notFoundTitle")}</h1>
        <p className="text-sm text-[var(--ink-muted)] font-serif-italic">
          {slug ? t("schrijven.leren.topic.notFoundDescriptionFmt", { slug }) : t("schrijven.leren.topic.notFoundNoSlug")}
        </p>
        <Link
          to="/schrijven/leren"
          className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          <span aria-hidden>←</span>
          <span>{t("schrijven.leren.topic.allChapters")}</span>
        </Link>
      </main>
    );
  }

  return (
    <main className="flex-1 mx-auto w-full max-w-3xl lg:max-w-4xl px-5 sm:px-6 py-8 sm:py-12 space-y-8">
      <Link
        to="/schrijven/leren"
        className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
      >
        <span aria-hidden>←</span>
        <span>{t("schrijven.leren.topic.allChapters")}</span>
      </Link>
      <SchrijvenTopicRenderer topic={topic} />
      <footer className="pt-8 border-t border-[var(--border)]">
        <Link
          to="/schrijven/leren"
          className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          <span aria-hidden>←</span>
          <span>{t("schrijven.leren.topic.backToChapters")}</span>
        </Link>
      </footer>
    </main>
  );
}
